import SelectionTrackingController from "./selection_tracking_controller"

export default class extends SelectionTrackingController {
  static values = {
    paramName: { type: String, default: "user_ids" }
  }

  initialize() {
    super.initialize()
    this.handleOnClick = this.handleOnClick.bind(this)
  }

  buttonTargetConnected() {
    this.buttonTarget.addEventListener("click", this.handleOnClick)
    this.updateButtonDisabledState()
  }

  handleOnClick(event) {
    event.preventDefault()

    const form = this.findForm()
    const hiddenInput = this.findHiddenInput(form)
    hiddenInput.value = this.selectedIds.join(",")

    form.submit()
  }

  findHiddenInput(form) {
    return form.querySelector(`input[name='${this.paramNameValue}']`) ||
           form.querySelector(`input[name='${this.paramNameValue}[]']`)
  }

  findForm() {
    const formId = this.buttonTarget.getAttribute("form")
    if (formId) {
      return document.getElementById(formId)
    }
    return this.buttonTarget.closest("form")
  }
}
